/** Geolocation icon button (top-right column). Behavior wired by the caller (DESIGN.md §7). */
export function createLocateButton(onClick: () => void): HTMLButtonElement {
  const btn = document.createElement("button");
  btn.type = "button";
  btn.className = "icon-button";
  btn.setAttribute("aria-label", "Pokaż moją lokalizację");
  btn.textContent = "◎";
  btn.addEventListener("click", onClick);
  return btn;
}
